import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { useAssetsMoveModel } from "../assetsMoveModel";
import Print from "./details/Print";

export function ManageAssetsMove() {
    const { selectedRowKeys } = useAssetsMoveModel();
    return (
        <>
            <PageHeader />
            <DataBox />
            <Print id={selectedRowKeys[0]} />
        </>
    );
}